var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({ background: _vm.event.branding.tertiaryColor })},[_c('h1',[_vm._v("ADMIN")])])
}
var staticRenderFns = []

export { render, staticRenderFns }